import { Component, OnInit, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import {
  AssessmentCriteria,
  GetSessionInput,
} from '../models/assessment-model';
import { AssessmentService } from '../services/assessment.service';
import { MasterDataService } from '../services/masterdata.service';
import { UserRolesService } from '../services/user-roles.service';
import { Observable, of } from 'rxjs';
import { SessionService } from '../services/session.service';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  tap,
  switchMap,
} from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneratePdf } from '../models/generatepdf-model';
import { TranslateService } from '@ngx-translate/core';
import $ from 'jquery';
declare var bootstrap: any;
@Component({
    selector: 'app-assessment',
    templateUrl: './assessment.component.html',
    styleUrls: ['./assessment.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AssessmentComponent implements OnInit {
  @ViewChild('noticeContent') private noticeContent;
  @ViewChild('maxPartcipantNotice') private maxPartcipantNotice;
  assessmentIdArray: any = [];
  showEmailUpdatePopup: boolean = false;
  emailPopupName: string = '';
  emailPopupEmail: string = '';
  emailPopupNewEmail: string = '';
  emailValidationMsg: string = '';
  userCountryId: number = 0;
  showEmailUpdateSave: boolean = false;
  showsessionPopupToValidation: boolean = false;
  totalCount: number = 0;
  searchSessionData: any;
  searchAreaFields: boolean = true;
  seaerchAreaDownArrow: boolean = false;
  seaerchAreaUpArrow: boolean = false;
  noRows: any;
  searchAssessmentData: any;
  searchAssessmentDataColumns: any;
  assessmentCriteria: AssessmentCriteria;
  baselines: any;
  selectAllChecked: boolean;
  sessioncountry: any;
  sessionList: any;
  sessionPopupName: string;
  sessionPopupEmail: string;
  sessionPopupisDeloitte: boolean = false;
  sessionFromID: string;
  sessionName: string;
  sessionPopupTo: string;
  selectedSessionToId: string = '';
  selectedAssessmentId: string = '';
  showCopySessionSave: boolean = false;
  selectedBaselineId: any = 'undefined';
  selectedSessionCountryId: number;
  subscriptionId: string = '';
  sessionNameorId: string = '';
  nameorEmailorUsername: string = '';
  companyOrganization: string = '';
  isLatest: boolean = true;
  assessmentType: number = 1;
  countryTextbox: string = '';
  countryIdArray: any = [];
  countrySuggestions: any = [];
  sessionSuggestions: any = [];
  countries: any;
  showAssessementGrid: boolean = false;

  showsessionNameorId: boolean = false;
  showNameorUserEmailVal: boolean = false;
  showSessionRadioBtn: boolean = false;

  showCompanyValidation: boolean = false;

  showSessionUpdatePopup: boolean = false;

  allowRowCheckboxInGrid: boolean = true;
  iseventRegistered: boolean = true;
  allowPagination: boolean = false;
  isClientSidePagination: boolean = true;
  totalRecord: number = 1;
  loggedInUserId: number = 0;

  showExportBtn: boolean = false;
  showSearchAndClear: boolean = false;
  showLoaderIcon: boolean = false;
  searchGridHeight: any;
  timeoutBool: any;
  selectAllCheckboxDisabled: boolean = false;
  rowCheckboxDisabled: boolean = false;
  currentUserRole: number;
  searching = false;
  searchFailed = false;
  selectedCompany = '';
  compNameErrorMsg = '';
  startDate: any = '';
  endDate: any = '';
  sessionStartDate: any;
  sessionEndDate: any;
  IsDateInvalid: boolean = false;
  invalidDateErrorMsg: string = '';
  searchByDate: any;
  isAdvanceSearch: boolean = false;
  selectedSearchbyDate: number = 0;
  disableDateRange: boolean = true;
  selectedLang: string;
  languageList = [];
  isUserSuperAdmin = false;
  userRoleList: any[] = [];
  tempSubscriptionId: string = '';
  allSessionCountries: any = [];
  isRoleIdLoad: boolean = false;

  get showSubscriptionId() {
    if (!this.isUserSuperAdmin) {
      return this.userRoleList.some((i) => i.roleId == 6);
    }
    return (
      this.userRoleService.roleId === 1 ||
      this.userRoleService.roleId === 6 ||
      this.userRoleService.roleId === 3
    );
  }

  constructor(
    private sessionService: SessionService,
    private assessmentService: AssessmentService,
    private masterDataService: MasterDataService,
    public userRoleService: UserRolesService,
    private modalService: NgbModal,

    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.selectedLang = 'en';
    this.languageList = [
      { name: 'English (US)', languageAbbrevation: 'en' },
      { name: 'Português', languageAbbrevation: 'pt' },
    ];
    this.reloadByQueryParams();
    this.baselines = [
      {
        id: 1,
        name: 'Business',
        description:
          'Default baseline that looks at your type relative to the "average" business\nprofessional - use this to pull results for most sessions',
      },
      {
        id: 2,
        name: 'Leadership',
        description:
          'Looks at your type relative to the "average" marketplace leader - only use when the\nsession is focused on relationships between executives',
      },
      {
        id: 3,
        name: 'Deloitte',
        description:
          'Looks at your type relative to the "average" Deloitte professional - only use\nfor internal sessions',
      },
    ];
    this.searchByDate = [
      {
        id: 2,
        name: 'Session Date',
      },
      {
        id: 1,
        name: 'Assessment Date',
      },
    ];
    this.selectedSessionCountryId = 1;

    this.sessioncountry = [
      {
        id: 1,
        name: 'Session Country/Location',
      },
      {
        id: 2,
        name: 'User Country/Location',
      },
    ];

    this.setIsUserSuperAdmin();

    if (this.masterDataService.masterData != undefined) {
      this.countries = [];
      if (
        this.masterDataService.masterData &&
        this.masterDataService.masterData.Countries &&
        this.masterDataService.masterData.Countries.length > 0
      ) {
        this.masterDataService.masterData.Countries.map((country) => {
          this.countries.push({
            id: country.ID,
            name: country.Name,
            countryCode: country.CountryCode,
            countryCodeId: country.ID,
          });
        });
        this.countries = this.countries.filter(
          (country) => country.id != 266
        );
        this.allSessionCountries = this.countries;
      }
    } else {
      this.masterDataService.getMasterDataDetails().subscribe((res) => {
        this.countries = [];
        if (
          this.masterDataService.masterData &&
          this.masterDataService.masterData.Countries &&
          this.masterDataService.masterData.Countries.length > 0
        ) {
          this.masterDataService.masterData.Countries.map((country) => {
            this.countries.push({
              id: country.ID,
              name: country.Name,
              countryCode: country.CountryCode,
              countryCodeId: country.ID,
            });
          });
          this.countries = this.countries.filter(
            (country) => country.id != 266
          );
          this.allSessionCountries = this.countries;
        }
      });
    }

    this.userRoleService.roleIdSubject.subscribe({
      next: (data) => {
        this.isRoleIdLoad = true;
        this.currentUserRole = data;
      },
      error: () => {
        this.isRoleIdLoad = true;
      },
    });
    this.autoPopulateOnTabChange();
  }
  @ViewChild('headerHeight')
  headerHeight: ElementRef;
  @ViewChild('searchFieldsHeight')
  searchFieldsHeight: ElementRef;

  reloadByQueryParams() {
    if (this.assessmentService.sessionNameToRedirect != '') {
      this.sessionNameorId = this.assessmentService.sessionNameToRedirect;
      this.selectedBaselineId = 1;
      this.assessmentType = 1;
      this.setSessionRadioVal();
      this.onSearchClick();
    }
  }
  ngAfterViewInit() {
    this.searchGridHeightSet();
  }
  onResize(event) {
    this.searchGridHeightSet();
  }

  // method to check if the user has super admin role or not
  setIsUserSuperAdmin() {
    this.userRoleService.getUserRoleList().subscribe((result: any) => {
      this.userRoleList = result ? result : [];
      if (result && result.some((i) => i.roleId == 1)) {
        this.isUserSuperAdmin = true;
      }
    });
  }

  searchGridHeightSet() {
    setTimeout(() => {
      const SearchFildsHeight =
        this.searchFieldsHeight?.nativeElement?.offsetHeight;
      const screenHeight = window.innerHeight;
      const totalDedVal = SearchFildsHeight + 170;
      if (
        Number(this.selectedSearchbyDate) !== 0 &&
        this.sessionStartDate != undefined
      ) {
        $('#startDate').removeClass('mandatoryDropdown');
      }
      if (Number(this.selectedSearchbyDate) !== 0 && this.sessionEndDate != undefined) {
        $('#endDate').removeClass('mandatoryDropdown');
      }
      return (this.searchGridHeight = screenHeight - totalDedVal + 'px');
    }, 300);
  }

  searchAreaExpand() {
    if (this.isAdvanceSearch) {
      setTimeout(() => {
        const element = document.querySelector('#accordion .accordion1');
        if (element) {
          element.classList.add('show');
          element.classList.remove('collapse');
        }
        //   $("#accordion .accordion1").collapse("show");
        //  var myCollapse = new bootstrap.Collapse(document.querySelector('#accordion .accordion1'), {
        //     show: true
        //     });
      }, 100);
    } else {
      setTimeout(() => {
        const element = document.querySelector('#accordion .accordion1');
        if (element) {
          element.classList.add('collapse');
          element.classList.remove('show');
        }
        // var myCollapse = new bootstrap.Collapse(document.querySelector('#accordion .accordion1'), {
        //     hide: true
        //     });
        //     $("#accordion .accordion1").collapse("hide");
      }, 100);
    }
    this.searchAreaFields = true;
    this.seaerchAreaDownArrow = false;
    this.seaerchAreaUpArrow = true;
    this.searchGridHeightSet();
  }
  searchAreaCollapse() {
    this.searchAreaFields = false;
    this.seaerchAreaDownArrow = true;
    this.seaerchAreaUpArrow = false;
    this.searchGridHeightSet();
  }
  onFocusOutSubscriptionID() {
    if (this.subscriptionId) {
      if (this.subscriptionId !== this.tempSubscriptionId) {
        this.tempSubscriptionId = this.subscriptionId;
        this.sessionService
          .getSubscriptionData(this.subscriptionId)
          .subscribe((res) => {
            if (res) {
              if (
                res['SubscriptionType'] != null &&
                res['SubscriptionType'].toLowerCase() === 'commercialization'
              ) {
                this.countries = this.countries.filter(
                  (item) => item.id != 259 && item.id != 265 && item.id != 266
                );
                this.countryTextbox = '';
              } else {
                this.allSessionCountries = this.allSessionCountries.filter(
                  (country) => country.id != 266
                );
                this.countries = this.allSessionCountries;
              }
            }
          });
      }
    } else {
      this.tempSubscriptionId = this.subscriptionId;
      this.allSessionCountries = this.allSessionCountries.filter(
        (country) => country.id != 266
      );
      this.countries = this.allSessionCountries;
    }
  }
  searchCompanies = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => (this.searching = true)),
      switchMap((term) =>
        this.sessionService.searchword(term, 0).pipe(
          tap(() => (this.searchFailed = false)),
          catchError(() => {
            this.searchFailed = true;
            return of([]);
          })
        )
      ),
      tap(() => (this.searching = false))
    );

  formatMatches = (value: any) => {
    if (typeof value == 'object') {
      return value.Name;
    } else if (typeof value == 'string') {
      return value;
    } else {
      return null;
    }
  };
  onCompanySelect(companyData) {
    if (companyData && companyData.item) {
      this.companyOrganization = companyData.item.Name;
      this.showCompanyValidation = false;
      this.validateSearch();
    }
  }
  onFocusOutCompany(event) {
    this.showCompanyValidation =
      event.target.value.length > 2 || event.target.value.length === 0
        ? false
        : true;
    this.selectedCompany = event?.target?.value;
  }
  countryChange(name): void {
    if (name != '') {
      const countryObj = this.countries.filter((b) => b.name == name);
      const lastStr = this.countryTextbox.split(', ').pop();
      this.countryTextbox = this.countryTextbox.slice(
        0,
        this.countryTextbox.length - lastStr.length
      );
      if (this.countryIdArray.indexOf(countryObj[0].id) === -1) {
        this.countryIdArray.push(countryObj[0].id);
        if (this.countryTextbox !== '') {
          this.countryTextbox = this.countryTextbox + name + ', ';
        } else this.countryTextbox = name + ', ';
      }
      this.countrySuggestions = [];
      this.validateSearch();
    }
    this.setSessionRadioVal();
  }

  public onSessionPopupClose() {
    this.showSessionUpdatePopup = false;
  }

  public onEmailUpdatePopupClose() {
    this.showEmailUpdatePopup = false;
  }

  public onSessionToBlur(event?) {
    this.sessionSuggestions = [];
  }

  public onCountryBlur(event) {
    this.countrySuggestions = [];
  }

  public suggestCountry() {
    this.onFocusOutSubscriptionID();
    if (this.countryTextbox === '') {
      this.countryChange('');
    }
    this.countryIdArray = [];

    this.countrySuggestions = [];

    const lastStr = this.countryTextbox.split(', ');
    if (this.countryTextbox !== '') {
      for (let i = 0; i < lastStr.length; i++) {
        const countryObj = this.countries.filter((b) => b.name == lastStr[i]);
        if (countryObj.length === 0)
          this.countrySuggestions = this.countries.filter((a) =>
            a.name.toLowerCase().includes(lastStr[i].toLowerCase())
          );
        else this.countryIdArray.push(countryObj[0].id);
      }
    }

    this.validateSearch();
  }

  onSearchClick() {
    this.showLoaderIcon = true;
    if (
      this.startDate != '' ||
      this.endDate != '' ||
      Number(this.selectedSearchbyDate) != 0 ||
      (this.selectedSessionCountryId !== 0 &&
        this.selectedSessionCountryId !== 1) ||
      this.countryTextbox !== ''
    ) {
      this.isAdvanceSearch = true;
    } else {
      this.isAdvanceSearch = false;
    }
    if (
      typeof this.companyOrganization === 'object' &&
      this.companyOrganization !== null
    ) {
      this.companyOrganization = this.selectedCompany;
    }
    if (this.showSearchAndClear) {
      if (
        !this.showNameorUserEmailVal &&
        !this.showCompanyValidation &&
        !this.showsessionNameorId &&
        (this.sessionNameorId.trim() !== '' || this.sessionNameorId === '') &&
        (this.subscriptionId.trim() !== '' || this.subscriptionId === '') &&
        (this.companyOrganization.trim() !== '' ||
          this.companyOrganization === '') &&
        (this.nameorEmailorUsername.trim() !== '' ||
          this.nameorEmailorUsername === '')
      ) {
        this.createGrid();
      } else {
        this.showLoaderIcon = false;
      }
    } else {
      this.showLoaderIcon = false;
    }
    this.setValuesToMasterDataObj();
  }

  createGrid() {
    this.showLoaderIcon = true;
    this.selectAllChecked = false;
    this.assessmentIdArray = [];
    this.searchAssessmentData = [];
    this.totalCount = 0;
    this.showAssessementGrid = false;
    this.showExportBtn = false;
    this.userRoleService.getLoggedInUserID().subscribe((id) => {
      this.loggedInUserId = Number(id);
    });

    if (this.assessmentType !== 3) {
      this.selectAllCheckboxDisabled = false;
      this.rowCheckboxDisabled = false;
    } else {
      this.selectAllCheckboxDisabled = true;
      this.rowCheckboxDisabled = true;
    }
    this.assessmentCriteria = {
      AssessmentType: this.assessmentType,
      BaselineID:
        this.selectedBaselineId == 'undefined' ? 0 : this.selectedBaselineId,
      CompanyData: this.companyOrganization,
      CountryIds: this.countryIdArray.toString(),
      Countrysearchtype: this.selectedSessionCountryId,
      IsLatest: Number(this.isLatest),
      SessionData: this.sessionNameorId,
      SubscriptionUniqueID:
        this.subscriptionId == undefined ? '' : this.subscriptionId,
      UserData: this.nameorEmailorUsername,
      UserID: this.loggedInUserId,
      StartDate: this.sessionStartDate,
      EndDate: this.sessionEndDate,
      SearchByDate: Number(this.selectedSearchbyDate),
    };
    if (this.currentUserRole === 3 || this.currentUserRole === 1) {
      if (this.assessmentType !== 1) {
        this.searchAssessmentDataColumns = [
          {
            name: 'FullName',
            header: 'Name',
            dataType: 'FullName',
            minWidth: '100px',
          },
          {
            name: 'Email',
            header: 'Email',
            dataType: 'Email',
            minWidth: '70px',
          },
          {
            name: 'SessionName',
            header: 'Session Name',
            dataType: 'string',
            minWidth: '80px',
          },
          {
            name: 'DateofSession',
            header: 'Session Date',
            dataType: 'date',
            minWidth: '40px',
          },
          {
            name: 'Version',
            header: 'Version',
            dataType: 'number',
            minWidth: '30px',
          },
          {
            name: 'AssessmentResultID',
            header: 'AssessmentID',
            dataType: 'number',
            minWidth: '40px',
          },
          {
            name: 'BaseLineName',
            header: 'Baseline',
            dataType: 'string',
            minWidth: '70px',
          },
          {
            name: 'GuardianPercentage',
            header: 'Guardian',
            dataType: 'percent',
            minWidth: '30px',
          },
          {
            name: 'PioneerPercentage',
            header: 'Pioneer',
            dataType: 'percent',
            minWidth: '30px',
          },
          {
            name: 'IntegratorPercentage',
            header: 'Integrator',
            dataType: 'percent',
            minWidth: '30px',
          },
          {
            name: 'DriverPercentage',
            header: 'Driver',
            dataType: 'percent',
            minWidth: '30px',
          },
        ];
      } else {
        this.searchAssessmentDataColumns = [
          {
            name: 'pdfIcon',
            header: 'pdfIcon',
            dataType: 'string',
            minWidth: '20px',
          },
          {
            name: 'FullName',
            header: 'Name',
            dataType: 'FullName',
            minWidth: '200px',
          },
          {
            name: 'Email',
            header: 'Email',
            dataType: 'Email',
            minWidth: '150px',
          },
          {
            name: 'SessionName',
            header: 'Session Name',
            dataType: 'string',
            minWidth: '180px',
          },
          {
            name: 'DateofSession',
            header: 'Session Date',
            dataType: 'date',
            minWidth: '40px',
          },
          {
            name: 'Version',
            header: 'Version',
            dataType: 'number',
            minWidth: '30px',
          },
          {
            name: 'AssessmentResultID',
            header: 'AssessmentID',
            dataType: 'number',
            minWidth: '40px',
          },
          {
            name: 'BaseLineName',
            header: 'Baseline',
            dataType: 'string',
            minWidth: '70px',
          },
          {
            name: 'GuardianPercentage',
            header: 'Guardian',
            dataType: 'percent',
            minWidth: '30px',
          },
          {
            name: 'PioneerPercentage',
            header: 'Pioneer',
            dataType: 'percent',
            minWidth: '30px',
          },
          {
            name: 'IntegratorPercentage',
            header: 'Integrator',
            dataType: 'percent',
            minWidth: '30px',
          },
          {
            name: 'DriverPercentage',
            header: 'Driver',
            dataType: 'percent',
            minWidth: '30px',
          },
        ];
      }
    } else if (this.assessmentType !== 1) {
      this.searchAssessmentDataColumns = [
        {
          name: 'FullName',
          header: 'Name',
          dataType: 'FullName',
          minWidth: '100px',
        },
        {
          name: 'Email',
          header: 'Email',
          dataType: 'string',
          minWidth: '70px',
        },
        {
          name: 'SessionName',
          header: 'Session Name',
          dataType: 'string',
          minWidth: '80px',
        },
        {
          name: 'DateofSession',
          header: 'Session Date',
          dataType: 'date',
          minWidth: '40px',
        },
        {
          name: 'Version',
          header: 'Version',
          dataType: 'number',
          minWidth: '30px',
        },
        {
          name: 'AssessmentResultID',
          header: 'AssessmentID',
          dataType: 'number',
          minWidth: '40px',
        },
        {
          name: 'BaseLineName',
          header: 'Baseline',
          dataType: 'string',
          minWidth: '70px',
        },
        {
          name: 'GuardianPercentage',
          header: 'Guardian',
          dataType: 'percent',
          minWidth: '30px',
        },
        {
          name: 'PioneerPercentage',
          header: 'Pioneer',
          dataType: 'percent',
          minWidth: '30px',
        },
        {
          name: 'IntegratorPercentage',
          header: 'Integrator',
          dataType: 'percent',
          minWidth: '30px',
        },
        {
          name: 'DriverPercentage',
          header: 'Driver',
          dataType: 'percent',
          minWidth: '30px',
        },
      ];
    } else {
      this.searchAssessmentDataColumns = [
        {
          name: 'pdfIcon',
          header: 'pdfIcon',
          dataType: 'string',
          minWidth: '20px',
        },
        {
          name: 'FullName',
          header: 'Name',
          dataType: 'string',
          minWidth: '200px',
        },
        {
          name: 'Email',
          header: 'Email',
          dataType: 'string',
          minWidth: '150px',
        },
        {
          name: 'SessionName',
          header: 'Session Name',
          dataType: 'string',
          minWidth: '180px',
        },
        {
          name: 'DateofSession',
          header: 'Session Date',
          dataType: 'date',
          minWidth: '40px',
        },
        {
          name: 'Version',
          header: 'Version',
          dataType: 'number',
          minWidth: '30px',
        },
        {
          name: 'AssessmentResultID',
          header: 'AssessmentID',
          dataType: 'number',
          minWidth: '40px',
        },
        {
          name: 'BaseLineName',
          header: 'Baseline',
          dataType: 'string',
          minWidth: '70px',
        },
        {
          name: 'GuardianPercentage',
          header: 'Guardian',
          dataType: 'percent',
          minWidth: '30px',
        },
        {
          name: 'PioneerPercentage',
          header: 'Pioneer',
          dataType: 'percent',
          minWidth: '30px',
        },
        {
          name: 'IntegratorPercentage',
          header: 'Integrator',
          dataType: 'percent',
          minWidth: '30px',
        },
        {
          name: 'DriverPercentage',
          header: 'Driver',
          dataType: 'percent',
          minWidth: '30px',
        },
      ];
    }

    this.showLoaderIcon = true;
    this.assessmentService
      .getAssessmentData(this.assessmentCriteria)
      .subscribe((x) => {
        this.showLoaderIcon = true;
        if (x && x.length > 0) {
          this.searchAssessmentData = x.sort((a, b) =>
            a.FullName.localeCompare(b.FullName)
          ); //.sort(["FullName", "ASC"]);
          this.showExportBtn = true;
          this.totalCount = x[0].TotalCount;
          this.showLoaderIcon = false;
          this.showAssessementGrid = true;
          this.searchAreaFields = false;
          this.seaerchAreaDownArrow = true;
          this.seaerchAreaUpArrow = false;
          this.showLoaderIcon = false;
          this.searchGridHeightSet();
        } else {
          this.showAssessementGrid = false;
          this.showExportBtn = false;
          this.totalCount = 0;
          this.showLoaderIcon = false;
          this.searchAreaFields = true;
        }
      });
  }
  validateSearch() {
    if (this.assessmentType === 3) {
      if (
        ((Number(this.selectedSearchbyDate) !== 0 &&
          this.startDate !== '' &&
          this.endDate !== '') ||
          this.subscriptionId !== '' ||
          this.nameorEmailorUsername.length > 2 ||
          this.sessionNameorId !== '' ||
          this.companyOrganization !== '' ||
          this.countryIdArray.length !== 0) &&
        !this.showCompanyValidation &&
        !this.showNameorUserEmailVal &&
        !this.showsessionNameorId
      ) {
        this.showSearchAndClear = true;
      } else {
        this.showSearchAndClear = false;
      }
    } else if (
      ((Number(this.selectedSearchbyDate) !== 0 &&
        this.startDate !== '' &&
        this.endDate !== '') ||
        this.subscriptionId !== '' ||
        this.nameorEmailorUsername.length > 2 ||
        this.sessionNameorId !== '' ||
        this.companyOrganization !== '' ||
        this.countryIdArray.length !== 0) &&
      this.selectedBaselineId !== 'undefined' &&
      !this.showCompanyValidation &&
      !this.showNameorUserEmailVal &&
      !this.showsessionNameorId
    ) {
      this.showSearchAndClear = true;
    } else {
      this.showSearchAndClear = false;
    }

    if (Number(this.selectedSearchbyDate) !== 0) {
      if (this.startDate == '' || this.startDate == null || this.startDate == undefined || 
        this.endDate == '' || this.endDate == null || this.endDate == undefined) {
        this.showSearchAndClear = false;
      }
    }
  }

  onNameorUserEmailChange() {
    if (
      this.nameorEmailorUsername.trim() === '' &&
      this.nameorEmailorUsername.length !== 0
    ) {
      this.showNameorUserEmailVal = true;
      return;
    }

    if (this.nameorEmailorUsername !== '') {
      if (this.nameorEmailorUsername.length < 3)
        this.showNameorUserEmailVal = true;
      else this.showNameorUserEmailVal = false;
    } else {
      this.showNameorUserEmailVal = false;
    }
    this.setSessionRadioVal();
    this.validateSearch();
  }

  onNameorUserEmailKeyup(event) {
    if (event.which == '13') {
      event.preventDefault();
    }
  }

  onSessionNameorIdChange() {
    if (this.sessionNameorId !== '') {
      if (this.sessionNameorId.length < 3) this.showsessionNameorId = true;
      else this.showsessionNameorId = false;
      if (this.assessmentType === 2 || this.assessmentType === 1) {
        this.selectAllCheckboxDisabled = false;
        this.rowCheckboxDisabled = false;
      } else {
        this.selectAllCheckboxDisabled = true;
        this.rowCheckboxDisabled = true;
      }
    } else {
      if (this.assessmentType === 2 || this.assessmentType === 3) {
        this.selectAllCheckboxDisabled = true;
        this.rowCheckboxDisabled = true;
      }
      this.showsessionNameorId = false;
    }
    this.setSessionRadioVal();
    this.validateSearch();
  }

  rowCheckboxClickEvent(data) {
    if (data.checked == true) {
      if (this.assessmentIdArray.length < 51) {
        this.assessmentIdArray.push({ AssessmentResultID: data.AssessmentResultID, UserCountryId: data.UserCountryId });
      } else {
        const index = this.assessmentIdArray.findIndex(item => item.AssessmentResultID === data.AssessmentResultID);
        if (index != -1) {
          this.assessmentIdArray.splice(index, 1);
        }
      }
    } else {
      const index = this.assessmentIdArray.findIndex(item => item.AssessmentResultID === data.AssessmentResultID);
      if (index != -1) {
        this.assessmentIdArray.splice(index, 1);
      }
    }
  }

  onCompanyChange() {
    if (
      this.companyOrganization.length < 3 &&
      this.companyOrganization.length > 0
    ) {
      this.showCompanyValidation = true;
      this.compNameErrorMsg =
        'Please enter at least 3 characters to perform search.';
    } else if (
      this.companyOrganization.length === 0 ||
      this.companyOrganization.length > 2
    ) {
      this.showCompanyValidation = false;
      this.compNameErrorMsg = '';
    }
    this.setSessionRadioVal();
    this.validateSearch();
  }

  onSelectAllClick(data) {
    this.assessmentIdArray = [];
    let i = 1;

    data.forEach((item) => {
      if (item.checked == false) this.assessmentIdArray = [];
      if (i > 51 && item.checked == true) item.checked = !item.checked;
      if (i < 51 && item.checked == true)
        this.assessmentIdArray.push({ AssessmentResultID: item.AssessmentResultID, UserCountryId: item.UserCountryId });

      i = i + 1;
    });
    this.searchAssessmentData = data;

    if (this.totalCount > 50 && this.assessmentIdArray.length >= 50) {
      this.modalService.open(this.maxPartcipantNotice, {
        backdrop: 'static',
        windowClass: 'lang-modal',
      }); //greater than 50 show warning msg
    }
  }

  suggestSession() {
    this.selectedSessionToId = '';
    this.showCopySessionSave = false;
    if (this.sessionPopupTo.length < 3 && this.sessionPopupTo.length > 0) {
      this.showsessionPopupToValidation = true;
      this.sessionSuggestions = [];
    } else {
      this.showsessionPopupToValidation = false;
      const getSessionInput: GetSessionInput = {
        isDeloitte: this.sessionPopupisDeloitte,
        emailId: this.sessionPopupEmail,
        searchKey: this.sessionPopupTo,
        sourceSession: this.sessionFromID,
      };

      if (this.sessionPopupTo !== '')
        this.assessmentService
          .getSessionToList(getSessionInput)
          .subscribe((x) => {
            this.sessionSuggestions = x;
          });
      else this.sessionSuggestions = [];
    }
  }

  onSaveCopySession() {
    this.assessmentService
      .saveCopySession(this.selectedAssessmentId, this.selectedSessionToId, this.userCountryId)
      .subscribe((x) => {
        if ((x = 'Assessment Results Copied.')) {
          this.createGrid();
        } else console.log(x);
      });
    this.showSessionUpdatePopup = false;
  }

  sessionChange(name, sessionid) {
    this.selectedSessionToId = sessionid;
    this.sessionPopupTo = name + ' (' + sessionid + ')';

    this.showCopySessionSave = true;
  }

  onClearClick() {
    this.isAdvanceSearch = false;
    this.searchAreaExpand();
    if (this.showSearchAndClear) {
      this.searchAssessmentData = [];
      this.countryIdArray = [];
      this.assessmentType = 1;
      this.selectedBaselineId = 'undefined';
      this.companyOrganization = '';
      this.selectedSessionCountryId = 1;
      this.isLatest = true;
      this.sessionNameorId = '';
      this.subscriptionId = '';
      this.nameorEmailorUsername = '';
      this.countryTextbox = '';
      this.showSearchAndClear = false;
      this.showExportBtn = false;
      this.showCompanyValidation = false;
      this.showsessionNameorId = false;
      this.showNameorUserEmailVal = false;
      this.assessmentIdArray = [];
      this.totalCount = 0;
      this.showSessionRadioBtn = false;
      this.showAssessementGrid = false;
      this.selectAllChecked = false;
      this.IsDateInvalid = false;
      this.invalidDateErrorMsg = '';
      this.showErrorMsgForBothDate = false;
      this.dateErrorMsg = '';
      this.selectedSearchbyDate = 0;
      this.startDate = '';
      this.endDate = '';
      this.sessionStartDate = undefined;
      this.sessionEndDate = undefined;
      this.disableDateRange = true;
      this.assessmentService.sessionNameToRedirect = '';
      this.setValuesToMasterDataObj();
      this.countries = this.allSessionCountries;
      this.tempSubscriptionId = '';
    }
  }

  public onExportClick() {
    this.showLoaderIcon = true;
    const loggedInUserID = this.userRoleService.loggedInUserId;
    const assessmentCriteria = {
      AssessmentType: this.assessmentType,
      BaselineID:
        this.selectedBaselineId == 'undefined' ? 0 : this.selectedBaselineId,
      CompanyData: this.companyOrganization,
      CountryIds: this.countryIdArray.toString(),
      Countrysearchtype: this.selectedSessionCountryId,
      IsLatest: Number(this.isLatest),
      SessionData: this.sessionNameorId,
      SubscriptionUniqueID:
        this.subscriptionId == undefined ? '' : this.subscriptionId,
      UserData: this.nameorEmailorUsername,
      UserID: loggedInUserID,
      StartDate: this.sessionStartDate,
      EndDate: this.sessionEndDate,
      SearchByDate: Number(this.selectedSearchbyDate),
    };
    this.assessmentService.getExport(assessmentCriteria).subscribe((res) => {
      const binaryData = [];
      binaryData.push(res);
      const url = window.URL.createObjectURL(
        new Blob(binaryData, { type: 'application/vnd.ms-excel' })
      );
      // create hidden dom element (so it works in all browsers)
      const a = document.createElement('a');
      a.setAttribute('style', 'display:none;');
      document.body.appendChild(a);
      // create file, attach to hidden element and open hidden element
      a.href = url;
      a.download = 'Assessment_Report.xls';
      a.click();
      this.showLoaderIcon = false;
    });
  }

  onRadioBtnClick(radioBtnName) {
    if (radioBtnName == 'Assessment') {
      this.isLatest = true;
      this.assessmentType = 1;
    } else if (radioBtnName == 'Active_Sessions') {
      this.isLatest = false;
      this.assessmentType = 2;
    } else if (radioBtnName == 'All_Assessments') {
      this.isLatest = false;
      this.assessmentType = 3;
    }
    this.validateSearch();
  }
  onEmailClick(data) {
    debugger;
    this.showEmailUpdatePopup = true;
    this.showEmailUpdateSave = false;
    this.emailPopupNewEmail = '';
    this.emailValidationMsg = '';
    this.emailPopupName = data.FullName;
    this.emailPopupEmail = data.Email;
    this.userCountryId = data.UserCountryId;
  }
  timeoutFunction() {
    const pattern = /^[A-Z0-9._%!-+-']+@([A-Z0-9-]+\.)+[A-Z]{2,10}$/i;
    if (!pattern.test(this.emailPopupNewEmail)) {
      this.emailValidationMsg = 'Please enter a valid email id.';
      this.showEmailUpdateSave = false;
    } else {
      this.emailValidationMsg = '';
      this.assessmentService
        .isdeloitteDomain(this.emailPopupEmail)
        .subscribe((x) => {
          if (x === true) {
            this.assessmentService
              .isdeloitteDomain(this.emailPopupNewEmail)
              .subscribe((y) => {
                if (y === true) {
                  this.assessmentService
                    .isExisitingUser(this.emailPopupNewEmail)
                    .subscribe((z) => {
                      if (z === false) {
                        this.showEmailUpdateSave = true;
                        this.emailValidationMsg = '';
                      } else {
                        this.emailValidationMsg = 'User is already in use.';
                        this.showEmailUpdateSave = false;
                      }
                    });
                } else {
                  this.emailValidationMsg = 'Please enter a valid email id.';
                  this.showEmailUpdateSave = false;
                }
              });
          } else {
            this.assessmentService
              .isdeloitteDomain(this.emailPopupNewEmail)
              .subscribe((p) => {
                if (p === true) {
                  this.emailValidationMsg = 'Please enter a valid email id.';
                  this.showEmailUpdateSave = false;
                } else {
                  this.assessmentService
                    .isExisitingUser(this.emailPopupNewEmail)
                    .subscribe((q) => {
                      if (q === false) {
                        this.showEmailUpdateSave = true;
                        this.emailValidationMsg = '';
                      } else {
                        this.emailValidationMsg = 'User is already in use.';
                        this.showEmailUpdateSave = false;
                      }
                    });
                }
              });
          }
        });
    }
  }

  emailValidation() {
    clearTimeout(this.timeoutBool);
    this.timeoutBool = setTimeout(() => {
      this.timeoutFunction();
    }, 800);
  }

  onSaveEmailUpdate() {
    this.showEmailUpdatePopup = false;
    this.assessmentService
      .saveEmailId(this.emailPopupEmail, this.emailPopupNewEmail, this.userCountryId)
      .subscribe((x) => {
        this.showEmailUpdateSave = false;
        this.showEmailUpdatePopup = false;
        this.emailPopupNewEmail = '';
        this.createGrid();
      });
  }
  onGenerateTeamSnapShotClick() {
    this.modalService.open(this.noticeContent, {
      backdrop: 'static',
      windowClass: 'lang-modal',
    });
  }

  onPdfIconClick(rowdata) {
    debugger;
    this.showLoaderIcon = true;
    this.translateService.use(this.selectedLang);
    sessionStorage.setItem(' lang ', this.selectedLang);
    const pdf = new GeneratePdf();
    const data = [];
    data.push({ ID: rowdata.UserId, UserCountryId: rowdata.UserCountryId });

    pdf.BaselineID = this.masterDataService.assessmentData.selectedBaselineId;
    pdf.Language = this.selectedLang;
    pdf.SelectedIds = data;
    pdf.Region = String(rowdata.UserCountryId);
    this.GetUIDforIndivisualReportAndDownload(pdf);
  }

  onNameClick(data) {
    this.showSessionUpdatePopup = true;
    this.selectedSessionToId = '';
    this.sessionPopupTo = '';
    this.showCopySessionSave = false;
    this.selectedAssessmentId = data.AssessmentResultID;
    this.sessionPopupName = data.FullName;
    this.sessionPopupEmail = data.Email;
    this.sessionPopupisDeloitte = data.IsDeloitte;
    this.sessionFromID = data['SessionID'];
    this.sessionName = data['SessionName'] + ' (' + data['SessionID'] + ')';
    this.userCountryId = data.UserCountryId;
  }

  public autoPopulateOnTabChange() {
    const assessmentData = this.masterDataService.assessmentData;
    if (assessmentData) {
      this.countryTextbox = assessmentData.countryTextbox
        ? assessmentData.countryTextbox
        : '';
      this.assessmentType = assessmentData.assessmentType
        ? assessmentData.assessmentType
        : 0;
      this.selectedBaselineId = assessmentData.selectedBaselineId
        ? assessmentData.selectedBaselineId
        : 0;
      this.companyOrganization = assessmentData.companyOrganization
        ? assessmentData.companyOrganization
        : '';
      this.countryIdArray = assessmentData.countryIdArray
        ? assessmentData.countryIdArray
        : '';
      this.selectedSessionCountryId = assessmentData.selectedSessionCountryId
        ? assessmentData.selectedSessionCountryId
        : 0;
      this.isLatest = assessmentData.isLatest ? assessmentData.isLatest : false;
      this.sessionNameorId = assessmentData.sessionNameorId
        ? assessmentData.sessionNameorId
        : '';
      this.subscriptionId = assessmentData.subscriptionId
        ? assessmentData.subscriptionId
        : '';
      this.nameorEmailorUsername = assessmentData.nameorEmailorUsername
        ? assessmentData.nameorEmailorUsername
        : '';
      this.showSessionRadioBtn = assessmentData.showSessionRadioBtn
        ? assessmentData.showSessionRadioBtn
        : false;
      this.showCompanyValidation = assessmentData.showCompanyValidation
        ? assessmentData.showCompanyValidation
        : false;
      this.showsessionNameorId = assessmentData.showsessionNameorId
        ? assessmentData.showsessionNameorId
        : false;
      this.showNameorUserEmailVal = assessmentData.showNameorUserEmailVal
        ? assessmentData.showNameorUserEmailVal
        : false;
      this.selectedSearchbyDate = assessmentData.selectedSearchbyDate
        ? assessmentData.selectedSearchbyDate
        : 0;
      this.countrySuggestions = this.countrySuggestions
        ? this.countrySuggestions
        : [];
      if (Number(this.selectedSearchbyDate) !== 0) {
        this.startDate = assessmentData.startDate;
        this.sessionStartDate = this.setDateFormat(assessmentData.startDate);

        $('#startDate').removeClass('mandatoryDropdown');

        this.endDate = assessmentData.endDate;
        this.sessionEndDate = this.setDateFormat(assessmentData.endDate);
        $('#endDate').removeClass('mandatoryDropdown');
        this.disableDateRange = false;
      }

      this.validateSearch();
      if (this.showSearchAndClear === true) this.onSearchClick();
    }
  }

  public setValuesToMasterDataObj() {
    const data = {
      countryTextbox: this.countryTextbox,
      assessmentType: this.assessmentType,
      selectedBaselineId: this.selectedBaselineId,
      companyOrganization: this.companyOrganization,
      countryIdArray: this.countryIdArray.toString(),
      selectedSessionCountryId: this.selectedSessionCountryId,
      isLatest: Number(this.isLatest),
      sessionNameorId: this.sessionNameorId,
      subscriptionId:
        this.subscriptionId == undefined ? '' : this.subscriptionId,
      nameorEmailorUsername: this.nameorEmailorUsername,
      showSessionRadioBtn: this.showSessionRadioBtn,
      showCompanyValidation: this.showCompanyValidation,
      showsessionNameorId: this.showsessionNameorId,
      showNameorUserEmailVal: this.showNameorUserEmailVal,
      selectedSearchbyDate: this.selectedSearchbyDate,
      startDate: this.startDate,
      endDate: this.endDate,
    };
    this.masterDataService.assessmentData = data;
  }
  public showErrorMsgForBothDate: boolean = false;
  public dateErrorMsg: string = '';

  validateDateInputValues(dt) {
    if (dt != '' && dt != undefined) {
      const reGoodDate =
        /^(?:(19|20)[0-9]{2}[\-.])(0[1-9]|1[012])[\-.](0[1-9]|[12][0-9]|3[01])$/;
      return reGoodDate.test(dt);
    } else {
      return true;
    }
  }

  onFocusOutDate() {
    if (
      (this.sessionStartDate != '' &&
        this.sessionStartDate != undefined &&
        (this.sessionEndDate == '' || this.sessionEndDate == undefined)) ||
      ((this.sessionStartDate == '' || this.sessionStartDate == undefined) &&
        this.sessionEndDate != '' &&
        this.sessionEndDate != undefined)
    ) {
      this.showErrorMsgForBothDate = true;
      this.dateErrorMsg = 'Both dates needed';
      this.IsDateInvalid = false;
      this.invalidDateErrorMsg = '';
      this.showSearchAndClear = false; //disable btn
    } else if (
      !this.validateDateInputValues(this.sessionStartDate) ||
      !this.validateDateInputValues(this.sessionEndDate)
    ) {
      this.showErrorMsgForBothDate = true;
      this.dateErrorMsg = 'Please enter valid date';
      this.IsDateInvalid = false;
      this.invalidDateErrorMsg = '';
      this.showSearchAndClear = false; //disable btn
    } else {
      this.showErrorMsgForBothDate = false;
      this.dateErrorMsg = '';
    }
    if (Number(this.selectedSearchbyDate) !== 0 && this.sessionStartDate == undefined) {
      $('#startDate').addClass('mandatoryDropdown');
    }
    if (Number(this.selectedSearchbyDate) !== 0 && this.sessionEndDate == undefined) {
      $('#endDate').addClass('mandatoryDropdown');
    }

    return this.showErrorMsgForBothDate;
  }
  setDateFormat(event) {
    if (event != null) {
      const year = event.year;
      const month = event.month <= 9 ? '0' + event.month : event.month;
      const day = event.day <= 9 ? '0' + event.day : event.day;
      const finalDate = year + '-' + month + '-' + day;
      return finalDate;
    }
  }

  //From Date
  onStartDateSelect(event) {
    this.sessionStartDate = this.setDateFormat(event);
    $('#startDate').removeClass('mandatoryDropdown');
  }

  //To Date
  onEndDateSelect(event) {
    this.sessionEndDate = this.setDateFormat(event);
    $('#endDate').removeClass('mandatoryDropdown');
  }
  enableDateRange(event) {
    if (Number(this.selectedSearchbyDate) !== 0) {
      this.disableDateRange = false;
    } else {
      this.IsDateInvalid = false;
      this.invalidDateErrorMsg = '';
      this.showErrorMsgForBothDate = false;
      this.dateErrorMsg = '';
      this.selectedSearchbyDate = 0;
      this.startDate = '';
      this.endDate = '';
      this.sessionStartDate = undefined;
      this.sessionEndDate = undefined;
      this.disableDateRange = true;
      this.validateSearch();
    }
  }
  onChangeOfInputFields() {
    const isDateValidRes = this.onFocusOutDate();
    if (isDateValidRes === false) {
      if (this.sessionStartDate != '' && this.sessionEndDate != '') {
        if (
          this.sessionStartDate > this.sessionEndDate ||
          this.sessionStartDate == 'undefined-undefined-undefined' ||
          this.sessionEndDate == 'undefined-undefined-undefined'
        ) {
          this.IsDateInvalid = true;
          this.invalidDateErrorMsg =
            'To Date should be greater than or equal to From Date.';
          this.showSearchAndClear = false;
          this.showErrorMsgForBothDate = false;
          this.dateErrorMsg = '';
          this.showSearchAndClear = false; //disable btn
          return false;
        } else {
          this.IsDateInvalid = false;
          this.invalidDateErrorMsg = '';
        }
      }

      if(this.selectedBaselineId !== 0 && this.selectedSearchbyDate !== 0) {
        if (
          this.sessionStartDate == '' ||
          this.sessionStartDate == undefined ||
          this.sessionStartDate == null ||
          this.sessionEndDate == '' ||
          this.sessionEndDate == undefined ||
          this.sessionEndDate == null
        ) {
          this.showSearchAndClear = false; //disable btn
        } else {
          this.showSearchAndClear = true; //enable btn
        }
      }
    }
  }

  ScrollIntoView(elem: string): void {
    setTimeout(() => {
      document
        .querySelector(elem)
        .scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 100);
  }

  setSessionRadioVal(): void {
    if (
      this.subscriptionId !== '' ||
      this.sessionNameorId !== '' ||
      (this.nameorEmailorUsername !== '' &&
        this.countryTextbox !== '' &&
        this.selectedSessionCountryId === 1) ||
      (this.nameorEmailorUsername !== '' && Number(this.selectedSearchbyDate) !== 0) ||
      (this.companyOrganization.length !== 0 &&
        Number(this.selectedSearchbyDate) !== 0) ||
      (this.countryTextbox !== '' &&
        this.selectedSessionCountryId !== 0 &&
        Number(this.selectedSearchbyDate) !== 0) ||
      (this.nameorEmailorUsername !== '' &&
        this.companyOrganization.length !== 0 &&
        this.countryTextbox !== '' &&
        this.selectedSessionCountryId !== 0) ||
      (this.nameorEmailorUsername !== '' &&
        this.companyOrganization.length !== 0 &&
        Number(this.selectedSearchbyDate) !== 0) ||
      (this.nameorEmailorUsername !== '' &&
        this.countryTextbox !== '' &&
        this.selectedSessionCountryId !== 0 &&
        Number(this.selectedSearchbyDate) !== 0) ||
      (this.companyOrganization.length !== 0 &&
        this.countryTextbox !== '' &&
        this.selectedSessionCountryId !== 0 &&
        Number(this.selectedSearchbyDate) !== 0)
    ) {
      this.showSessionRadioBtn = true;
    } else {
      this.onRadioBtnClick('Assessment');
      this.showSessionRadioBtn = false;
    }
    this.validateSearch();
  }

  clickOK(): void {
    this.showLoaderIcon = true;
    this.translateService.use(this.selectedLang);
    sessionStorage.setItem(' lang ', this.selectedLang);
    const pdf = new GeneratePdf();
    if (this.assessmentIdArray.length > 0) {
      const data = [];
      for (const x in this.assessmentIdArray) {
        if (this.assessmentIdArray.hasOwnProperty(x)) {
          const temp = this.assessmentIdArray[x];
          if (temp) {
            data.push({ ID: temp.AssessmentResultID, UserCountryId: temp.UserCountryId });
          }
        }
      }
      $('#teamSnapshot').val(JSON.stringify(data));

      pdf.BaselineID = this.masterDataService.assessmentData.selectedBaselineId;
      pdf.Language = this.selectedLang;
      pdf.SelectedIds = data;
      pdf.Region = String(this.userCountryId);
      this.GetLanguageSpecificFileNameAndDownloadFile_v2(pdf);
    }
  }

  onLanguageChange(event): void {
    console.log(this.selectedLang);
  }
  GetUIDforIndivisualReportAndDownload(pdf: GeneratePdf) {
    this.assessmentService.sendtoPostPDf(pdf).subscribe((d: any) => {
      const uid = d;
      this.assessmentService.getPDFBlob(uid, pdf.Region).subscribe(
        (result: any) => {
          const binaryData = [];
          binaryData.push(result.blob);
          const url = window.URL.createObjectURL(
            new Blob(binaryData, { type: 'application/pdf' })
          );
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.href = url;
          a.download = result.fileName;
          a.click();
          this.showLoaderIcon = false;
        },
        (error: any) => {
          this.showLoaderIcon = false;
        },
        () => {
          this.showLoaderIcon = false;
        }
      );
    });
  }
  GetLanguageSpecificFileNameAndDownloadFile_v2(pdf: GeneratePdf) {
    this.assessmentService.sendtoPostPDf(pdf).subscribe((d: any) => {
      const fileNameToDownload: string = 'BC Team Snapshot.pdf';

      this.assessmentService
        .downloadTeamSnapshotReport(
          d,
          pdf.Language,
          pdf.BaselineID,
          fileNameToDownload
        )
        .subscribe(
          (res) => {
            const binaryData = [];
            binaryData.push(res);
            const url = window.URL.createObjectURL(
              new Blob(binaryData, { type: 'application/pdf' })
            );
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            a.href = url;
            a.download = fileNameToDownload;
            a.click();
            this.showLoaderIcon = false;
          },
          (error: any) => {
            this.showLoaderIcon = false;
          },
          () => {
            this.showLoaderIcon = false;
          }
        );
    });
  }

  formatDate(param, lang) {
    const m_names = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    const mpt_names = [
      'Janeiro',
      'Fevereiro',
      'Mar�o',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ];

    const d = new Date(param);
    const curr_date = d.getDate();
    const curr_month = d.getMonth();
    const curr_year = d.getFullYear();
    if (lang == 'pt')
      return mpt_names[curr_month] + ' ' + curr_date + ', ' + curr_year;
    else return m_names[curr_month] + ' ' + curr_date + ', ' + curr_year;
  }

  transformScoresData(data) {
    const count = [];
    count['Pioneer'] = 1;
    count['Guardian'] = 1;
    count['Integrator'] = 1;
    count['Driver'] = 1;

    for (const x in data.Scores) {
      if (data.Scores.hasOwnProperty(x)) {
        const temp = data.Scores[x].XYPoint;

        temp.Key = 50 + (temp.Key - 0.25) * 100 * 2;
        temp.Value = 50 - (temp.Value - 0.25) * 100 * 2;

        temp.Key = temp.Key * 0.945;
        temp.Value = temp.Value * 0.945;

        temp.Key = temp.Key + 4;
        temp.Value = temp.Value + 4;

        data.Scores[x].Count = count[data.Scores[x].PrimaryType];
        count[data.Scores[x].PrimaryType]++;
      }
    }
  }

  //Bug 3703820 fix
  GetLanguageSpecificFileNameAndDownloadFile(language, uri) {
    const xrhFile = new XMLHttpRequest();
    let langObject: any;
    let fileNameToDownload: string = 'BC Team Snapshot.pdf';

    const self = this;
    xrhFile.open(
      'GET',
      '../../../../ResourceFiles/JSON_Files/TeamSnapshot/' + language + '.json',
      false
    );
    xrhFile.onreadystatechange = function () {
      if (xrhFile.readyState === 4) {
        if (xrhFile.status === 200 || xrhFile.status === 0) {
          langObject = JSON.parse(xrhFile.responseText);
          fileNameToDownload =
            langObject['FileNameToDownload'] != null &&
            langObject['FileNameToDownload'] != undefined
              ? langObject['FileNameToDownload']
              : fileNameToDownload;
          self.assessmentService.sendtoGetPDf(uri, fileNameToDownload);
        } else {
          self.assessmentService.sendtoGetPDf(uri, fileNameToDownload);
        }
      }
    };
    xrhFile.send();
  }
}
